import * as React from "react";
import {
    List,
    Show,
    Edit,
    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,

    TabbedShowLayout,
    Tab,
    BooleanInput,
    Create,
    PasswordInput,
    NumberInput,
    ImageField,
    useRecordContext,
    useRefresh,
    useUpdate,
    FileField,
    Button,
    WrapperField,
    Toolbar,
    SaveButton,
    InfiniteList,
    ReferenceManyField,
    SingleFieldList,
    ChipField,
    FunctionField,
    EditButton,
    TabbedForm,
    AutocompleteArrayInput,
    useGetIdentity,
} from 'react-admin';
import Grid from '@mui/material/Grid';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { apiUrl, authenticatedApi, baseUrl, setAccessToken } from "../dataProvider";
import { stateAbbrToName } from "../helpers/strings";
import { ReferenceManyToManyInput } from "@react-admin/ra-relationships";
import { CommunityOptionRenderer, GenericOptionRenderer } from "../Components/OptionRenderer";

{/* <QuickFilter source="views_lte" label="Low views" defaultValue={150} />, */}
const listFilters = [
    <TextInput source="q" label="Search" alwaysOn />,
];

const UserList = props => (
    <InfiniteList title={"All Users"} filters={listFilters} {...props} exporter={false} /*hasCreate*/>
        <Datagrid rowClick="show">
            <TextField source="email" />
            <TextField source="name" />

            {/*
            <ArrayField source="communities">
                <SingleFieldList>
                    <ChipField source="name" />
                </SingleFieldList>
            </ArrayField>
            */}

            <FunctionField label="Communities" render={record => `${record.communities.length}`} />

            <FunctionField label="Coordinating Programs" render={record => `${record.coordinating_programs.length}`} />

            <EditButton/>
        </Datagrid>
    </InfiniteList>
);

const ImpersonateUserButton = (props) => {
    // const { className, emptyText, source, ...rest } = props;
    const record = useRecordContext(props);
    const refresh = useRefresh();
    const [update, { isLoading, error }] = useUpdate();
    // const value = get(record, source);
    const [isDisabled, setIsDisabled] = React.useState(false);

    return (
        <Button
            label="Impersonate User"
            disabled={isDisabled}
            onClick={(e) => {
                e.stopPropagation();
                setIsDisabled(true);
                authenticatedApi.post(`${apiUrl}/harmony-impersonate?id=${record.id}`).then((response) => {
                    setAccessToken(false); // destroy harmony token

                    window.location = baseUrl;

                    // refresh();
                    setTimeout(() => {
                        setIsDisabled(false);
                    }, 500);
                }).catch(response => {
                    alert('Impersonation failed.');
                    setIsDisabled(false);
                });
            }}
        />
    );
};

const UserShow = props => (
    <Show {...props} title={'View User'}>
        {/* <SimpleShowLayout> */}
        <TabbedShowLayout>
            <Tab label="Summary">
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <SimpleShowLayout>
                            <TextField source="name" />
                            <EmailField source="email" />
                            <BooleanField label="Is MSA Admin?" source="is_msa" looseValue />
                            <BooleanField label="Is Staff?" source="is_staff" looseValue />
                            <DateField source="updated_at" />
                        </SimpleShowLayout>
                    </Grid>
                    {/*
                    <Grid item xs={6}>
                        <Typography component="h2" variant="h6" gutterBottom>Impersonate User</Typography>
                        <Typography gutterBottom>This will log you in as the user. To become yourself again, log out and back in.</Typography>
                        <ImpersonateUserButton />
                    </Grid>
                    */}
                </Grid>

            </Tab>
            <Tab label="Communities">
                <ArrayField source="communities" label={false}>
                    <Datagrid rowClick={(id, resource, record) => '/communities/'+id+'/show'} bulkActionButtons={false} sort={{field: 'name'}}>
                        <TextField sortable={false} source="name" />

                        <TextField sortable={false} source="city" />
                        <FunctionField sortable={false} label="State" source="state" render={record => stateAbbrToName(record.state)} />

                        {/* <DateField source="created_at" label={'Created'} /> */}
                    </Datagrid>
                </ArrayField>
            </Tab>

            <Tab label="Coordinating Programs">
                <ArrayField source="coordinating_programs" label={false}>
                    <Datagrid rowClick={(id, resource, record) => '/coordinating-programs/'+id+'/show'} bulkActionButtons={false} sort={{field: 'name'}}>
                        <TextField sortable={false} source="name" />

                        <FunctionField sortable={false} label="State" source="state" render={record => stateAbbrToName(record.state)} />
                        {/* <TextField source="state" /> */}

                        {/* <DateField source="created_at" label={'Created'} /> */}
                    </Datagrid>
                </ArrayField>
            </Tab>
        {/* </SimpleShowLayout> */}
        </TabbedShowLayout>
    </Show>
)

const EditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

const IsMsaCheckbox = props => {
    const { data: identity, isLoading: identityLoading } = useGetIdentity();
    // const record = useRecordContext();

    // Only let MSA users to set MSA status
    if(!identity?.is_msa) {
        return null;
    }

    return (<BooleanInput {...props} />);
};

const IsStaffCheckbox = props => {
    const { data: identity, isLoading: identityLoading } = useGetIdentity();
    // const record = useRecordContext();

    // Only let MSA users to set Staff status
    if(!identity?.is_msa) {
        return null;
    }

    return (<BooleanInput {...props} />);
};

const UserEdit = props => (
    <Edit {...props} redirect="show" mutationMode="pessimistic" transform={data => ({
        ...data,
        confirm_password: data.password,
    })}>
        <TabbedForm>
            <TabbedForm.Tab label="Summary">
                {/* <Grid container spacing={2}> */}
                    {/* <Grid item xs={6}> */}
                        {/* <Stack> */}
                            <TextInput source="name" isRequired />
                            <TextInput source="email" isRequired />

                            <IsMsaCheckbox label="Is MSA Admin?" source="is_msa" />
                            <IsStaffCheckbox label="Is Staff?" source="is_staff" />
                        {/* </Stack> */}
                    {/* </Grid> */}
                    {/* <Grid item xs={6}> */}
                        <PasswordInput source="password" label="New Password" helperText={'Only set this if resetting password.'} />
                    {/* </Grid> */}
                {/* </Grid> */}
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Communities">
                <ReferenceManyToManyInput reference="communities" through="community-user" using="user_id,community_id" perPage={-1} perPageChoices={-1}>
                    <AutocompleteArrayInput label="Communities" optionText={<CommunityOptionRenderer/>} inputText={choice => choice.name} />
                </ReferenceManyToManyInput>
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Coordinating Programs">
                <Alert severity="info"><b>Only use this box if the user is a staff member of the coordinating program.</b><br/>Adding a user to a coordinating program will give them permission to review all form entries for that program(s).<br/>Do not give this access to local program users.</Alert>
                <ReferenceManyToManyInput reference="coordinating-programs" through="coordinating-program-user" using="user_id,coordinating_program_id" perPage={-1} perPageChoices={-1}>
                    <AutocompleteArrayInput label="Coordinating Programs" optionText={<GenericOptionRenderer/>} inputText={choice => choice.name} />
                </ReferenceManyToManyInput>
            </TabbedForm.Tab>
        </TabbedForm>
    </Edit>
);

const UserCreate = props => (
    <Create {...props} redirect="show">
        <TabbedForm>
            <TabbedForm.Tab label="Summary">
                {/* <Grid container spacing={2}> */}
                    {/* <Grid item xs={6}> */}
                        {/* <Stack> */}
                            <TextInput source="name" isRequired />
                            <TextInput source="email" isRequired />

                            <IsMsaCheckbox label="Is MSA Admin?" source="is_msa" format={v => !!v ? 1 : 0} parse={v => !!v ? 1 : 0} />
                            <IsStaffCheckbox label="Is Staff?" source="is_staff" format={v => !!v ? 1 : 0} parse={v => !!v ? 1 : 0} />
                        {/* </Stack> */}
                    {/* </Grid> */}
                    {/* <Grid item xs={6}> */}
                        <PasswordInput source="password" label="Password" helperText={'Leave blank to automatically generate a password.'} />
                    {/* </Grid> */}
                {/* </Grid> */}
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Communities">
                <ReferenceManyToManyInput reference="communities" through="community-user" using="user_id,community_id" perPage={-1} perPageChoices={-1}>
                    <AutocompleteArrayInput label="Communities" optionText={<CommunityOptionRenderer/>} inputText={choice => choice.name} />
                </ReferenceManyToManyInput>
            </TabbedForm.Tab>
            <TabbedForm.Tab label="Coordinating Programs">
                <Alert severity="info"><b>Only use this box if the user is a staff member of the coordinating program.</b><br/>Adding a user to a coordinating program will give them permission to review all form entries for that program(s).<br/>Do not give this access to local program users.</Alert>
                <ReferenceManyToManyInput reference="coordinating-programs" through="coordinating-program-user" using="user_id,coordinating_program_id" perPage={-1} perPageChoices={-1}>
                    <AutocompleteArrayInput label="Coordinating Programs" optionText={<GenericOptionRenderer/>} inputText={choice => choice.name} />
                </ReferenceManyToManyInput>
            </TabbedForm.Tab>
        </TabbedForm>
    </Create>
);

export {UserList, UserShow, UserEdit, UserCreate};
